import React from 'react';
import PropTypes from 'prop-types';
import { DatePicker as InlineDatePicker } from '@material-ui/pickers';

const DatePicker = ({
	value,
	onChange,
	...rest
}) => (
	<InlineDatePicker
		variant="inline"
		inputVariant="outlined"
		value={value || null}
		onChange={onChange}
		format="YYYY-MM-DD"
		emptyLabel=""
		{...rest}
	/>
);

DatePicker.propTypes = {
	value: PropTypes.any.isRequired,
	onChange: PropTypes.func.isRequired,
};

export default DatePicker;
